

import {Component, Vue} from "vue-property-decorator";

@Component({})
export default class Contact extends Vue {
  name!: "Contact";

  pathToPics = require.context('../assets/', false, /\.[jpn]{2}g$/);

  getPic(name: string): string {
    return this.pathToPics('./'.concat(name))
  }

}
